import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import FontPlugin from '@ckeditor/ckeditor5-font/src/font'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ListPlugin from '@ckeditor/ckeditor5-list/src/list'
import MentionPlugin from '@ckeditor/ckeditor5-mention/src/mention'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import PasteFromOfficePlugin from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import RemoveFormatPlugin from '@ckeditor/ckeditor5-remove-format/src/removeformat'
import _ from 'lodash'

import {store} from 'src/store/store'
import Constants from "./constants";

export default {
  plugins: [
    AlignmentPlugin,
    BoldPlugin,
    EssentialsPlugin,
    FontPlugin,
    ItalicPlugin,
    HeadingPlugin,
    LinkPlugin,
    ListPlugin,
    MentionPlugin,
    MentionCustomization,
    ParagraphPlugin,
    PasteFromOfficePlugin,
    RemoveFormatPlugin
  ],
  alignment: {
    options: ['left', 'center', 'right']
  },
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'heading',
      '|',
      'alignment',
      '|',
      'fontFamily',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'bold',
      'italic',
      '|',
      'link',
      '|',
      'numberedList',
      'bulletedList',
      '|',
      'removeFormat'
    ]
  },
  mention: {
    feeds: [
      {
        marker: '@',
        feed: getFilteredUsers,
        minimumCharacters: 1,
        itemRenderer: userItemRenderer
      }]
  }
}

function userItemRenderer (item) {
  const itemElement = document.createElement('span')

  itemElement.style.width = '100%'
  itemElement.style.display = 'inline-block'
  itemElement.classList.add('custom-item')
  itemElement.id = `mention-list-item-id-${item.userId}`
  itemElement.textContent = `${item.name}`

  return itemElement
}

function getFilteredUsers(queryText) {
  const users = _.filter(store.state.users.results,
    (user) => user.name.toLowerCase().startsWith(queryText.toLowerCase())
      && user.active).slice(0, 10)

  const autocompleteUsers = []
  users.forEach((user) => {
    autocompleteUsers.push({
      id: '@' + user.name,
      userId: user.id,
      name: user.name
    })
  })
  return autocompleteUsers
}

function MentionCustomization (editor) {
  editor.conversion.for('upcast').elementToAttribute({
    view: {
      name: 'span',
      key: 'data-mention',
      classes: 'mention',
      attributes: {
        'data-user-id': true,
        'notification-id': true
      }
    },
    model: {
      key: 'mention',
      value: viewItem => {
        // The mention feature expects that the mention attribute value
        // in the model is a plain object with a set of additional attributes.
        // In order to create a proper object use the toMentionAttribute() helper method:
        const mentionAttribute = editor.plugins.get('Mention').toMentionAttribute(viewItem, {
          // Add any other properties that you need.
          userId: viewItem.getAttribute('data-user-id'),
          notificationId: viewItem.getAttribute('notification-id') || ''
        })

        return mentionAttribute;
      }
    },
    converterPriority: 'high'
  })

  // Downcast the model 'mention' text attribute to a view <a> element.
  editor.conversion.for('downcast').attributeToElement({
    model: 'mention',
    view: ( modelAttributeValue, viewWriter ) => {
      // Do not convert empty attributes (lack of value means no mention).
      if (!modelAttributeValue) {
        return
      }

      return viewWriter.createAttributeElement('span', {
        class: 'mention ptrac-mentions',
        'data-mention': modelAttributeValue.id,
        'data-user-id': modelAttributeValue.userId,
        'notification-id': modelAttributeValue.notificationId || '',
        contenteditable: 'false'
      })
    },
    converterPriority: 'high'
  })
}
